import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TextButton } from '../Button/TextButton/TextButton-IOcIGCYB.js';
import { I as Icon } from '../Icon/Icon-QOd-wyJ6.js';

const CloseButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30074613__sc-fkvn1o-0"
})(["align-self:start;flex:0 0 auto;outline:none;"]);
CloseButton.displayName = 'StyledButton';
const CloseButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30074613__sc-fkvn1o-1"
})(["color:", ";opacity:1;font-size:", ";padding:0 5px 0 5px;:hover{opacity:1.0;color:", ";cursor:pointer;}", ""], ({
  $isSolid,
  theme,
  $alertType
}) => $isSolid ? theme.message[$alertType].solidCloseButtonColor : theme.icon.color, ({
  header,
  theme
}) => header ? theme.message.closeButtonIconSizeHeader : theme.message.closeButtonIconSize, ({
  $isSolid,
  theme,
  $alertType
}) => $isSolid ? theme.message[$alertType].solidCloseButtonColor : theme.icon.hover.color, isMobile(css(["font-size:", ";"], ({
  header,
  theme
}) => header ? theme.message.mobile.closeButtonIconSizeHeader : theme.message.mobile.closeButtonIconSize)));
CloseButtonIcon.displayName = 'StyledIcon';

export { CloseButton as C, CloseButtonIcon as a };
//# sourceMappingURL=CloseButton-Di74WyQn.js.map
